import { CardItem } from '@bloomays-lib/ui.shared';

import { ITalent, ProfileNetwork } from '@bloomays-lib/types.shared';
import { getATSTalentUrl, getProfileByNetwork } from '@bloomays-lib/utils.shared';
import { ActionMenuItem } from '../components/organisms/ResponsiveActionMenu';
import { styled } from '@mui/material/styles';
import { ClipboardCopy, Logo } from '@bloomays-lib/ui.shared';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import lk from '../graphic-charter/icons/LK.svg';
import toit from '../graphic-charter/icons/toit.svg';
import hw from '../graphic-charter/icons/hellowork.svg';
import hs from '../graphic-charter/icons/HireSweet.svg';
import cv from '../graphic-charter/icons/CV.svg';
import redirect from '../graphic-charter/icons/redirect.svg';
import config from './configService';

export const getTalentActions = (
  talent: ITalent,
  origin: 'searchPage' | 'talentPage',
  handleOpenSyncTalent: () => void,
) => {
  const LK = getProfileByNetwork(talent?.profiles || [], ProfileNetwork.LinkedIn);
  const TOIT = getProfileByNetwork(talent?.profiles || [], ProfileNetwork.TurnoverIT);
  const HW = getProfileByNetwork(talent?.profiles || [], ProfileNetwork.HelloWork);
  const HSUrl = talent?.hiresweetId ? getATSTalentUrl(config().env, talent.hiresweetId) : undefined;
  const urlFullTalentSheet = `${import.meta.env.VITE_PUBLIC_APP_ENDPOINT}talents/${talent.id}`;

  // Préparation des actions pour le menu responsive
  const actions: ActionMenuItem[] = [
    ...(HSUrl
      ? [
          {
            icon: <StyledHoverLogo image={hs} alt={`Hiresweet Url`} />,
            label: 'Hiresweet',
            onClick: () => window.open(HSUrl),
          },
        ]
      : []),
    ...(HW?.url
      ? [
          {
            icon: <StyledHoverLogo image={hw} alt={`${ProfileNetwork.HelloWork} Url`} />,
            label: 'HelloWork',
            onClick: () => window.open(HW.url),
          },
        ]
      : []),
    ...(TOIT?.url
      ? [
          {
            icon: <StyledHoverLogo image={toit} alt={`${ProfileNetwork.TurnoverIT} Url`} />,
            label: 'TurnoverIT',
            onClick: () => window.open(TOIT.url),
          },
        ]
      : []),
    ...(LK?.url
      ? [
          {
            icon: <StyledHoverLogo image={lk} alt="Linkedin Url" />,
            label: 'LinkedIn',
            onClick: () => window.open(LK.url),
          },
        ]
      : []),
    {
      icon: <ClipboardCopy copyText={urlFullTalentSheet} />,
      label: 'Copier le lien',
      onClick: undefined,
    },
    ...(origin === 'searchPage'
      ? [
          {
            icon: <StyledHoverLogo image={redirect} alt="Ouvrir la fiche" />,
            label: 'Ouvrir la fiche',
            onClick: () => window.open(urlFullTalentSheet, '_blank'),
          },
        ]
      : []),
    ...(origin === 'searchPage' && talent.cv
      ? [
          {
            icon: <StyledHoverLogo image={cv} alt="Voir le CV" />,
            label: 'Voir le CV',
            onClick: () => window.open(talent.cv, '_blank'),
          },
        ]
      : []),
    {
      icon: <CardItem variant={'pink'} size={'extraSmall'} emoji={<AddShoppingCartIcon />} />,
      label: 'Ajouter au panier',
      onClick: () => handleOpenSyncTalent(), // Action à définir si besoin
    },
  ];

  return actions;
};

const StyledHoverLogo = styled(Logo)(
  () => `
  &:hover {
    cursor: pointer;
  }
  width: 24px;
  height: 24px;
`,
);
